import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function IsUrlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;
    const error = { isNotUrl: true };

    if (value === '') {
      return null;
    }

    try {
      if (typeof value !== 'string') {
        return error;
      } else {
        const urlRegex =
          /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
        const isValid = urlRegex.test(value);
        new URL(value);

        return isValid ? null : error;
      }
    } catch {
      return error;
    }
  };
}
